import createAction from 'redux-actions/es/createAction';

export const initApplication = createAction('INIT_APPLICATION');
